<template>
    <v-snackbar
        :timeout="3000"
        :offset="1"
        v-model="snackbar"
        :color="current.color"
        location="top center"
        :min-width="350"
        :min-height="60"
    >
        <p class="text-white">{{current.message}}</p>
        <template #actions>
            <v-btn icon="close" @click="snackbar = false" color="white"></v-btn>
        </template>
    </v-snackbar>
</template>

<script setup>
const toast = useToastStore();
const snackbar = ref(false);
const current = ref({color: 'success', message: 'test'})
watch([snackbar, toast.queue], () => {
    setTimeout(() => {
        if (snackbar.value == false && toast.queue.length) {
            current.value = toast.queue.shift();
            snackbar.value = true;
        }
    }, 100);
})
</script>
